export default class ObservationResidency {
  id!: number
  residency_id!: number
  observation!: string
  date!: Date
}
